import { RefObject, useEffect } from "react";

export const useClickOutSideComponent = (
  refs: RefObject<Element | null>[],
  handler: () => void
): void => {
  const clickHandler = (e: Event) => {
    const isInside = refs.some(
      (ref) => ref.current && ref.current.contains(e.target as Node)
    );

    if (!isInside) {
      handler();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", clickHandler);
    return () => {
      document.removeEventListener("mousedown", clickHandler);
    };
  }, [refs]);
};
